import clsx from "clsx";
import { Outlet } from "react-router-dom";
import { Region } from "../../components";
import { Toolbar } from "../../components/toolbar";
import { ModelProvider, OutlinerProvider } from "../../context";
import { Viewport } from "../../lib";

type Props = {
    viewport: Viewport;
    loading: boolean;
};

export const MobileViewer = ({ viewport, loading }: Props) => {
    return (
        <OutlinerProvider viewport={viewport}>
            <Outlet context={{ viewport: viewport, loading: loading, isMobile: true }} />

            <Region className={clsx("mobile", loading && "loading")} placement="bottom">
                <ModelProvider viewport={viewport}>
                    {!loading && <Toolbar isMobile={true} viewport={viewport} />}
                </ModelProvider>
            </Region>
        </OutlinerProvider>
    );
};
